import React from 'react';
require('../cart.css');

const Cart  = props => {

	return(
     <div  className="cart-section">
       <p>No Placed Cart yet!!</p>
     </div>
		);

}
export default Cart;